<template>
  <div class="vertical-break"></div>
</template>
<script>
export default {
  name: "VerticalBreak",
};
</script>

<style scoped>
.vertical-break {
  min-width: 1px;
  width: 1px;
  margin-inline: 2em;
  background: linear-gradient(to bottom, #0000, var(--dark-clr), #0000);
  opacity: 0.4;
  align-self: stretch;
}
</style>
